<template>
  <section class="content">
    <!--<template v-for="alert in alerts">
      <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
        <h4>
          <i v-if="alert.type === 'success' || alert.type === 'warning'" class="icon fa fa-check"></i>
          <i class="icon fa fa-ban" v-else></i>
          {{`alert_${alert.type}` | translate}}!</h4>
        {{alert.message}}
      </b-alert>
    </template>-->
    <add-device-modal v-if="sde1Active()" :storeId="$route.params.id" @alert="handleResponse" @loading="handleLoading" @reload="reloadDevices"></add-device-modal>
    <store-address-basic-modal @sendDataToParent ="postDataBasic($event)" :prefix = prefixForModal :addressForModal = storeData></store-address-basic-modal>
    <store-addresses-modal @sendDataToParent ="postDataForReturnShipping($event)" :addressForModal = storeData :prefix = prefixForModal></store-addresses-modal>
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <span v-if="loading">
                <i class="fa fa-spinner fa-spin mr-5"></i>
              </span>
              <span v-else>
                {{storeData.name}}
              </span></h3>
            <div class="box-tools pull-right">
              <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
              </button>
            </div>
          </div>
          <div class="box-controls">
            <div class="row">
              <div class="col-md-12 col-xs-12">
                <ul class="list-group">
                  <li class="list-group-item"><b>{{'contact_email' | translate}}</b><a :href="'mailto:' + storeData.contact_email" class="pull-right">{{storeData.contact_email}}</a></li>
                  <li class="list-group-item"><b>{{'order_email' | translate}}</b><a :href="'mailto:' + storeData.order_email" class="pull-right">{{storeData.order_email}}</a></li>
                  <li v-if="sde1Active()" class="list-group-item"><b>Click&amp;Collect-Email:</b><a :href="'mailto:' + storeData.click_collect_email" class="pull-right"><span v-if="storeData.click_collect_email !== false">{{storeData.click_collect_email}}</span></a></li>
                  <li class="list-group-item"><b>{{'contact_phone' | translate}}:</b><a :href="'tel:' + storeData.contact_phone" class="pull-right">{{storeData.contact_phone}}</a></li>
                  <li class="list-group-item"><b>ERP Store ID:</b><a class="pull-right">{{storeData.erp_store_id}}</a></li>
                  <li class="list-group-item"><b>{{'store_rank' | translate}}:</b><a class="pull-right">{{storeData.ranking}}</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="box-body">
            <div class="row pb-10">
              <div class="col-md-3 col-sm-6 col-xs-12">
                <h4><i class="fa fa-map mr-5"></i>{{'store_address' | translate}}:</h4>
                <p class="pt-10"><strong>{{storeData.name}}</strong><br>{{storeData.contact_name}}<br>{{storeData.street}} {{storeData.street_no}}<br>{{storeData.zip_code}} {{storeData.city}}</p><p>{{storeData.country}}</p>
                <button class="btn btn-info btn-sm" data-toggle="modal" data-target="#edit-store-basic-modal"  @click="setValueForModal('basic')" aria-expanded="false"><i class="fa fa-edit mr-5"></i>{{'edit_store' | translate }}</button>
               </div>
              <div class="col-md-3 col-sm-6 col-xs-12 border-left">
                <h4><i class="fa fa-truck mr-5"></i>{{'shipping_address' | translate}}:</h4>
                <p class="pt-10"><strong>{{storeData.shipping_name}}</strong><br>{{storeData.shipping_street}} {{storeData.shipping_street_no}}<br>{{storeData.shipping_zip_code}} {{storeData.shipping_city}}</p><p>{{storeData.shipping_country}}</p><br>
                <button class="btn btn-info btn-sm" data-toggle="modal" @click="setValueForModal('shipping');" data-target="#edit-store-shipping-return-pickup" aria-expanded="false"><i class="fa fa-edit mr-5"></i>{{'edit_store' | translate }}</button>
              </div>
              <div class="col-xs-12 visible-sm">
                <hr>
              </div>
              <div class="col-md-3 col-sm-6 col-xs-12 border-left border-right">
                <h4><i class="fa fa-refresh mr-5"></i>{{'return_address' | translate}}:</h4>
                <p class="pt-10"><strong>{{storeData.return_name}}</strong><br>{{storeData.return_street}} {{storeData.return_street_no}}<br>{{storeData.return_zip_code}} {{storeData.return_city}}</p><p>{{storeData.return_country}}</p><br>
                <button class="btn btn-info btn-sm" data-toggle="modal"  @click="setValueForModal('return');" data-target="#edit-store-shipping-return-pickup" aria-expanded="false"><i class="fa fa-edit mr-5"></i>{{'edit_store' | translate }}</button>
              </div>
              <div class="col-md-3 col-sm-6 col-xs-12">
                <h4><i class="fa fa-map-marker mr-5"></i>PickUp-Adresse:</h4>
                <p class="pt-10"><strong>{{storeData.pickup_name}}</strong><br>{{storeData.pickup_street}} {{storeData.pickup_street_no}}<br>{{storeData.pickup_zip_code}} {{storeData.pickup_city}} <br> {{storeData.pickup_phone}}</p><p>{{storeData.pickup_country}}</p>
                <button class="btn btn-info btn-sm" data-toggle="modal" @click="setValueForModal('pickup');" data-target="#edit-store-shipping-return-pickup" aria-expanded="false"><i class="fa fa-edit mr-5"></i>{{'edit_store' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div v-if="sde1Active()" class="row pb-10">
        <div class="col-xs-12">
          <div class="box box-primary">
          <div class="box-header with-border">
            <h4 class="box-title">
            <i class="fa fa-mobile mr-5"></i> Q-SCAN App - Devices
          </h4>
            <div class="box-tools pull-right">
              <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
              </button>
            </div>
          </div>
        <div class="box-body">
          <div class="col-xs-12">
          <div v-if="devices && devices.length > 0" class="table-responsive">
            <table class="table table-hover">
              <thead>
              <tr>
                <th>Device ID</th>
                <th>{{'in_use_by' | translate}}</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <store-devices-row v-for="device in devices" :original="device" :storeId="$route.params.id" :key="`device-${device.id}`" :parentLoading="loadingDevices" @reload="reloadDevices" @loading="handleLoading" @update="device = $event"></store-devices-row>
              </tbody>
            </table>
          </div>
          <div v-else>
         <div class="row pb-10">
            <div class="callout callout-warning ">
              <h4><i class="fa fa-exclamation-triangle mr-5"></i>{{'info' | translate}}</h4>
              <p>{{'no_devices' | translate}}</p>
            </div>
          </div>
        </div>
          </div>
        </div>
        <div class="box-footer text-right">
          <button class="btn btn-success pull-right" data-toggle="modal" data-target="#addDeviceModal"><i class="fa fa-plus mr-5"></i>{{'add_new_device' | translate}}</button>
        </div>
        </div>
        </div>
      </div>
  </section>
</template>
<script>
import { sde1Active } from '@/sunset-helper'
import StoreDevicesRow from '../../tools/TableRows/StoreDevicesRow'
import StoreAddressBasicModal from '../../tools/Modals/StoreAddressBasicModal';
import StoreAddressesModal from '../../tools/Modals/StoreAddressesModal';
export default {
  name: 'SingleStore',
  components: {StoreDevicesRow, StoreAddressBasicModal, StoreAddressesModal},
  data () {
    return {
      test: 'test',
      devices: [],
      newDevices: [],
      alerts: [],
      storeData: {},
      prefixForModal: '',
      loading: true,
      loadingDevices: false
    }
  },
  methods: {
    sde1Active,
    postDataBasic (address) {
      let data = {
        'name': address.corrected_name,
        'contact_name': address.corrected_contact_name,
        'order_email': address.corrected_order_email,
        'contact_email': address.corrected_contact_email,
        'click_collect_email': address.corrected_click_collect_email,
        'contact_phone': address.corrected_contact_phone,
        'erp_store_id': address.corrected_erp_store_id,
        'ranking': address.corrected_ranking,
        'street': address.corrected_street,
        'street_no': address.corrected_street_no,
        'zip_code': address.corrected_zip_code,
        'city': address.corrected_city,
        'country': address.corrected_country
      }
      this.updateAddressFunction(data);
    },
    postDataForReturnShipping(address) {
      let data =
        {
          [this.prefixForModal + '_name']: address['corrected_' + this.prefixForModal + '_name'],
          [this.prefixForModal + '_street']: address['corrected_' + this.prefixForModal + '_street'],
          [this.prefixForModal + '_street_no']: address['corrected_' + this.prefixForModal + '_street_no'],
          [this.prefixForModal + '_zip_code']: address['corrected_' + this.prefixForModal + '_zip_code'],
          [this.prefixForModal + '_city']: address['corrected_' + this.prefixForModal + '_city'],
          [this.prefixForModal + '_country']: address['corrected_' + this.prefixForModal + '_country']
        }
      if (address.hasOwnProperty('corrected_' + this.prefixForModal + '_phone')) {
        data[this.prefixForModal + '_phone'] = address['corrected_' + this.prefixForModal + '_phone']
      }
      this.updateAddressFunction(data);
    },
    updateAddressFunction(data){
      API.put(`/accounting/stores/${this.$route.params.id}`, data)
        .then(response => {
          let alert = {dismiss: 4, type: 'success', message: 'Update Successful'}
          this.$store.commit('pushAlert', alert);
          this.getStoresAndStoresDevices();
        }, error => {
          if (this.$store.dispatch('checkError', error)) {
            let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
            this.$store.commit('pushAlert', alert)
          }
        })
    },
    handleLoading () {
      this.loadingDevices = !this.loadingDevices
    },
    reloadDevices () {
      if (!this.sde1Active()) {
        return
      }
      API.get(`/accounting/stores/${this.$route.params.id}/wsDevices`)
        .then(res => {
          this.devices = res.data
          this.loadingDevices = false
        })
    },
    setValueForModal(value) {
      this.prefixForModal = ''
      this.$nextTick(() => {
        this.prefixForModal = value;
      })
    },
    handleResponse (value) {
      this.$store.commit('pushAlert', value)
    },
    deleteFromArray (device) {
      this.devices.splice(this.devices.indexOf(device), 1)
    },
    getStoresAndStoresDevices(){
      if (this.$store.dispatch('checkPermissions', 'co_accounting')) {
        let requests = [API.get(`/accounting/stores/${this.$route.params.id}`)]
        if (this.sde1Active()) {
          requests.push(API.get(`/accounting/stores/${this.$route.params.id}/wsDevices`))
        }
        API.all(requests)
          .then(API.spread((response, devices) => {
            for (let i in response.data) {
              this.$set(this.storeData, i, response.data[i])
            }
            this.devices = devices ? devices.data : []
            this.loading = false
          }))
          .catch(errors => {
            this.loading = false
            this.$store.dispatch('checkError', errors)
            errors = errors.response
            let alert = {type: 'danger', dismiss: 4, message: errors.data.message}
            this.$store.commit('pushAlert', alert)
          })
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getStoresAndStoresDevices();
    })
  },
}
</script>

<style>
  select option.normal{
    margin:40px;
    color:#fff;
    text-shadow:0 1px 0 rgba(0,0,0,.4);
    background:#202227
  }
</style>
<style scoped>
  .loading-gif {
    padding-top: 8px;
    padding-bottom: 15px;
    width: 15%;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Accounting/SingleStore.vue